import { IConnector } from '../Tools/connectors'

const cmDescriptionFirstPart = 'Use the Anypoint Custom Metrics connector to send operational and business'
const cmDescriptionSecondPart = 'metric values and the dimensions you customize, to Anypoint Monitoring.'
const customMetricsDescription = `${cmDescriptionFirstPart} ${cmDescriptionSecondPart}`

const CustomMetricsConnectorMule3: IConnector = {
  title: 'Custom Metrics Connector - Mule 3',
  description: customMetricsDescription,
  link: 'https://anypoint.mulesoft.com/exchange/com.mule.modules/mule-custom-metrics-connector/',
  type: 'Mule-3-connector'
}

const CustomMetricsConnectorMule4: IConnector = {
  title: 'Custom Metrics Connector - Mule 4',
  description: customMetricsDescription,
  link: 'https://anypoint.mulesoft.com/exchange/com.mule.modules/mule-custom-metrics-extension/',
  type: 'Mule-4-connector'
}

export const sendMetricsConnectors = [
  CustomMetricsConnectorMule3,
  CustomMetricsConnectorMule4,
]
